<div
  class="side-dialog-container"
  data-testid="side-dialog"
  [class.!h-full]="fullHeight()"
  [style.padding-right.px]="paddingRight()"
>
  <div class="dialog-header">
    <ng-content select="[dialogHeader]" />
    <div class="dialog-header-actions self-baseline">
      <button
        mat-icon-button
        data-testid="side-dialog-close-button"
        class="mat-secondary-transparent-button-color mat-big-icon-button"
        [attr.aria-label]="'shared.close' | translate"
        (click)="close()"
      >
        <app-icon src="icons/close.svg" class="w-6 h-6" />
      </button>
    </div>
  </div>

  <div
    class="dialog-content overflow-x-hidden -mx-3 px-3"
    [class.!h-full]="fullHeight()"
    [style.marginTop.px]="contentMarginTop()"
  >
    <ng-content select="[dialogContent]" />
  </div>
</div>
